import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const ABOUT_IMG_NEW = 'https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/9726d35b-8449-478e-a740-c11a3e0679a5_patrickjuri.jpg?v=fce5efd3115805d233b2877734421185'; // Patrick juri

export default function AboutSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" ref={sectionRef} className="bg-white py-16 md:py-28 px-4 md:px-6 lg:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Image */}
          <div
            className={`transition-all duration-700 ${
              inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'
            }`}
          >
            <div className="relative w-full max-w-md mx-auto lg:mx-0">
              <div className="aspect-[4/5] rounded-3xl overflow-hidden bg-gray-100">
                <img
                  src={ABOUT_IMG_NEW}
                  alt="Patrick Serafini — Advogado Criminalista"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div
            className={`transition-all duration-700 delay-200 ${
              inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <span className="font-cinzel text-grey text-sm tracking-wide">Quem Sou</span>
            <h2 className="font-cinzel font-bold text-navy text-2xl md:text-4xl lg:text-5xl mt-2 leading-tight">
              Sobre Patrick Serafini
            </h2>
            <div className="mt-6 space-y-4">
              <p className="font-montserrat font-light text-grey text-base md:text-lg leading-relaxed">
                Advogado especialista em Direito Criminal, atuo com dedicação exclusiva na defesa
                de clientes em situações criminais complexas e urgentes. Minha prática é guiada
                pela busca incansável pela justiça e pelo respeito absoluto aos direitos
                individuais de cada pessoa.
              </p>
              <p className="font-montserrat font-light text-grey text-base md:text-lg leading-relaxed">
                Experiência consolidada com atuação em Machado, Alfenas, Pouso Alegre e todo Sul de Minas,
                oferecendo uma abordagem técnica e humanizada, compreendendo que cada caso envolve
                não apenas uma questão jurídica, mas também a vida, a liberdade e a dignidade de uma pessoa.
              </p>
              <p className="font-montserrat font-light text-grey text-base md:text-lg leading-relaxed">
                Atendo casos de flagrante, audiência de custódia, tribunal do júri, revisão criminal
                e processos da Lei Maria da Penha, sempre com ética, estratégia e comprometimento
                total com o melhor resultado possível.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-3">
              <span className="font-montserrat font-medium text-navy text-sm bg-green-soft px-4 py-2 rounded-full">
                OAB/MG 236.997
              </span>
              <span className="font-montserrat font-medium text-navy text-sm bg-green-soft px-4 py-2 rounded-full">
                Sul de Minas
              </span>
              <span className="font-montserrat font-medium text-navy text-sm bg-green-soft px-4 py-2 rounded-full">
                24h
              </span>
            </div>
            <div className="mt-8">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-green-cta text-navy font-montserrat font-semibold text-sm px-6 py-3 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                Falar com o Advogado no WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}